export const sortRaces = (races) => {
  return races.sort((a, b) => {
    return parseDate(a.date) - parseDate(b.date);
  });
};

const parseDate = (dateStr) => {
  const currentYear = new Date().getFullYear();
  const cleanStr = dateStr.replace(/(st|nd|rd|th)/, "");
  const fullDateStr = `${cleanStr} ${currentYear}`;
  return new Date(fullDateStr);
};
